import dayjs from "dayjs";
import { DateWithoutTime } from "../../shared/util/date.util";
import { IPomAnnouncementTableData, } from "../components/announcement-table/pom-announcement-table-data";
import { PomProductUnit } from "../components/product-table/pom-product-table-data";

export class AnnouncementUtil {
  /**
   * Checks if the provided table data is invalid.
   * Currently only checks when either count or totalWeight is 0, the other value has to be 0 as well
   * @param data the announcement table data
   */
  public static isAnnouncementTableDataInvalid(data: IPomAnnouncementTableData): boolean {
    return (data.count === 0 && data.totalWeight !== 0) || (data.totalWeight === 0 && data.count !== 0);
  }

  /**
   * Check if the given weight is in the range of the lower and upper weight limit
   * @param data the announcement table data
   */
  public static isAnnouncementTableDataWeightInvalid(data: IPomAnnouncementTableData): boolean {
    if (!data.count || !data.totalWeight) {
      return false;
    }

    const lowerLimitPerItemInGram = data.lowerWeightLimitInGram ?? 0;
    const upperLimitPerItemInGram = data.upperWeightLimitInGram ?? Number.MAX_VALUE;

    const totalLowerLimitInKg = (lowerLimitPerItemInGram / 1000) * data.count;
    const totalUpperLimitInKg = (upperLimitPerItemInGram / 1000) * data.count;

    return data.totalWeight < totalLowerLimitInKg || data.totalWeight > totalUpperLimitInKg;
  }

  public static calculatePrice(
    unit: PomProductUnit,
    price: number,
    count: number | undefined,
    weight: number | undefined,
  ): number | undefined {
    if (unit === "STK") {
      return count ? count * price : undefined;
    } else {
      return weight ? weight * price : undefined;
    }
  }
}

export const getYearlyAnnouncementDate = (contractStartDate: DateWithoutTime): Date => {
  const currentYear = dayjs().startOf("year");
  const contractYear = dayjs(contractStartDate).startOf("year");

  // Only allow 3 years into the past if the contract start date is older than 3 years
  if (currentYear.get("year") - contractYear.get("year") >= 3) {
    return currentYear.subtract(3, "year").toDate();
  } else {
    return contractYear.toDate();
  }
};
